import Immutable from 'immutable';
// types
import MenuTypes from '~/constants/types/MenuTypes';

export function initialState() {
  return Immutable.Map({
    contextual: true,
    blurCanvas: false
  });
}

export default function menu(state = initialState(), action) {
  switch (action.type) {
    case MenuTypes.TOGGLE_CONTEXTUAL:
      return state.set('contextual', !state.get('contextual'));
    case MenuTypes.TOGGLE_CANVAS_BLUR:
      return state.set('blurCanvas', action.payload);
    default:
      return state;
  }
}
